// File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageContentArea = styled.div({
	padding: `10px ${token('space.200', '16px')} 0 ${token('space.200', '16px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageNoteMacroSkeleton = styled.div({
	width: '254px',
	height: '22px',
	background: token('color.background.accent.purple.subtler', '#DFD8FD'),
	borderRadius: '4px',
	padding: token('space.075', '6px'),
	marginBottom: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageContentTextSkeleton = styled.div<{
	width: string;
	marginBottom?: string;
	marginLeft?: string;
	backgroundColor?: string;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: (props) => `${props.width}px`,
	height: '4px',
	position: 'relative',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) =>
		props.backgroundColor
			? props.backgroundColor
			: token('color.background.discovery.pressed', '#B8ACF6'),
	borderRadius: '5.7px',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginBottom: (props) =>
		props.marginBottom ? `${props.marginBottom}px` : token('space.050', '4px'),
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginLeft: (props) => `${props.marginLeft}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CheckboxContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
	marginBottom: token('space.075', '6px'),
	marginLeft: token('space.negative.050', '-4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageContentTitle = styled.div({
	fontSize: '8px',
	lineHeight: '9.55px',
	fontWeight: '600',
	color: token('color.text', '#172B4D'),
	marginBottom: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageContentPurpleSubtitle = styled.div({
	fontSize: '5px',
	fontWeight: '600',
	lineHeight: '6px',
	color: token('color.text.accent.purple', '#5E4DB2'),
	marginBottom: token('space.025', '2px'),
	height: '6px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageContentSubtitle = styled.div({
	fontSize: '5.7px',
	fontWeight: '600',
	lineHeight: '7px',
	color: token('color.text', '#172B4D'),
	marginBottom: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageColumnsWrapper = styled.div({
	display: 'flex',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageColumn = styled.div({
	display: 'flex',
	flexDirection: 'column',
});
